import Mutations from '../../odata/mutations';

export default { ...new Mutations('marketManBuyer'), ...new Mutations('marketManBuyers') };
